<script setup lang="ts">
import { ref } from 'vue';
import { useUserAgentState } from '~/composables/useUserAgentState';

const { isFromNavel } = useUserAgentState();

type Nav = {
  text: string;
  to: string;
  external?: boolean;
  newWindow?: boolean;
};

const navs: Nav[] = [
  {
    text: 'ニュース',
    to: '/public/article/news',
  },
  {
    text: 'レシピ',
    to: '/public/article/recipe/top',
  },
];

const isShowSpMenu = ref(false);
const isShowSpSearch = ref(false);

function openMenu() {
  isShowSpMenu.value = true;
}

function closeMenu() {
  isShowSpMenu.value = false;
}

function openSearch() {
  isShowSpSearch.value = true;
}

function closeSearch() {
  isShowSpSearch.value = false;
}
</script>

<template>
  <header class="md:hidden">
    <AtomsAppBanner />

    <div
      v-if="!isFromNavel"
      class="py-1 flex justify-between items-center"
      data-testid="logo-menu-search"
    >
      <button
        class="shrink-0 p-2 h-[44px]"
        date-testid="open-menu-button"
        @click="openMenu"
      >
        <img src="~/assets/img/header_toggle.png" class="h-full" />
      </button>
      <div class="shrink-0 h-full">
        <NuxtLink to="/"><AtomsDietPlusLogo class="w-[100px]" /></NuxtLink>
      </div>
      <button
        class="shrink-0 p-2 h-[44px]"
        date-testid="open-search-button"
        @click="openSearch"
      >
        <img src="~/assets/img/header_search.png" class="h-full" />
      </button>
    </div>

    <div class="flex grow border-b border-gray-300">
      <NuxtLink
        v-for="nav in navs"
        :key="nav.to"
        :to="nav.to"
        :external="nav.external"
        class="text-gray-500 py-2 w-full text-center"
        :target="nav.newWindow ? '_blank' : undefined"
        :rel="nav.newWindow ? 'noopener' : undefined"
        >{{ nav.text }}</NuxtLink
      >
    </div>

    <OrganismsDietPlusSpHeaderMenu :is-show="isShowSpMenu" @close="closeMenu" />

    <OrganismsDietPlusSpHeaderSearch
      :is-show="isShowSpSearch"
      @close="closeSearch"
    />
  </header>
</template>
